export default __webpack_public_path__ + "static/media/Qe_2.c759ae6a.JPG";